<la-error-state-card [title]="title" [body]="body" [showGoToMaps]="showGoToMaps" (goToMaps)="handleGoToMaps()"></la-error-state-card>
